import type { ComingSoonContent } from '@/core/types';

import { ComingSoon } from '@/containers/blocks/other';

export default function generate({
  content,
  className,
}: {
  content: ComingSoonContent;
  className?: string;
}) {
  const date = content?.date ? new Date(content.date) : undefined;
  const socialLinks = content?.socialLinks;
  return <ComingSoon date={date} socialLinks={socialLinks} className={className} />;
}
